import createSelector from 'web-app/util/custom-create-selector';
import RoutesMap from 'signin-app/routes/routes-map';
import { isPinApp } from 'signin-app/login/selectors';
import { makeStaffSelector, getPinEmployee } from '../selectors';
export const isCheckingOut = (state) => state.employeeCheckOut.isCheckingOut;
const entityStaffSelector = makeStaffSelector(RoutesMap.employeeCheckOut);
export const employee = createSelector(isPinApp, getPinEmployee, entityStaffSelector, (pinApp, pinEmployee, entityStaff) => {
    if (pinApp) {
        return pinEmployee;
    }
    return entityStaff;
});
